export const pressReleaseQuotesArticle = {
  title: 'Press Release Generator: Quotes & Contacts',
  slug: 'press-release-quotes',
  content: `Press Release Generator: Quotes & Contacts

Quotes and contact details are required to finalize a press release.

1) Add quotes
- Use the “Add Quote” control to include multiple spokespeople.
- Each quote needs a name, title, and the quote text.

2) Set press contact
- Add contact name, title, email, and phone.

3) Validate before submit
- The generator requires company name, headline topic, contact name, and contact email.
`,
};
